import Icon from '../components/Icon';

const Weather23 = Icon(
  'weather-23',
  <>
    <path d="M2 11.25a.75.75 0 0 1 0-1.5h16.75a1.5 1.5 0 0 0 0-3c-.68 0-1.346.47-1.547 1.01a.75.75 0 0 1-1.406-.52c.435-1.175 1.696-1.99 2.953-1.99a3 3 0 0 1 0 6zM4 13.25a.75.75 0 0 0 0 1.5h9a1.5 1.5 0 1 1 0 3c-.68 0-1.346-.47-1.547-1.01a.75.75 0 1 0-1.406.52c.435 1.175 1.696 1.99 2.953 1.99a3 3 0 0 0 0-6z" />
  </>
);

export default Weather23;
